import { IconGlobe, Text } from 'braid-design-system';

interface Props {
  nationalities: string;
}

export const Nationality = ({ nationalities }: Props) => (
  <Text
    icon={<IconGlobe tone="secondary" data={{ testid: 'nationality-icon' }} />}
    size="small"
  >
    {nationalities}
  </Text>
);
